import React, { useMemo } from 'react';
import { useQuery } from 'react-query';

import DataGrid from 'components/DataGrid';
import { DataGridColDef, DataGridProps } from 'components/DataGrid/DataGrid';

import DF from 'DisplayFramework';
import { getListpayFile } from 'services/PaymentServices';
import Button from 'components/Button';
export type PayListProps = Pick<DataGridProps<any>, 'rowSelection'> & {
  isModal?: string;
  onSelect?: (item: any) => void;
  hideCIListModal?: () => void;
  hideCol?: boolean;
  hideExtraAction?: boolean;
};
const ListFilePaymentAvailble = (props: PayListProps) => {
  const { onSelect } = props;

  const { data, refetch, isFetching } = useQuery(['getListpayFile'], () =>
    getListpayFile().then((res) => {
      return res.list || [];
    })
  );

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'filename',
        width: 80,
        fixed: 'left',
        render: (val, record) => (
          <a onClick={() => onSelect && onSelect(val)}>{val}</a>
        ),
      },
      {
        dataIndex: 'date',
        width: 120,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [refetch]
  );

  return (
    <DF.Provider pagcode="filepaylist">
      <DataGrid
        rowKey="payid"
        dataSource={data}
        titleComcode="filepaylist"
        columns={columns}
        hideFilters
        hideExtraAction
        isLoading={isFetching}
        extraActions={<Button type="primary" comcode="run" />}
        pagination={false}
      />
    </DF.Provider>
  );
};

export default ListFilePaymentAvailble;
